import React from "react";
import { Card, Descriptions, Avatar, Space, Switch, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../../store";
import { UserOutlined } from "@ant-design/icons";
import { toggle2FA } from "../../../store/slices/authSlice";

const ProfilePage: React.FC = () => {
  const { user, username, isLoading } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();

  const handleToggle2FA = async (checked: boolean) => {
    try {
      await dispatch(toggle2FA(checked)).unwrap();
      message.success(`Two-factor authentication ${checked ? 'enabled' : 'disabled'} successfully`);
    } catch (error) {
      message.error('Failed to update two-factor authentication settings');
    }
  };

  return (
    <Card title="Profile" style={{ maxWidth: 800, margin: "0 auto" }}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          {user?.photo ? (
            <Avatar size={120} src={user.photo} />
          ) : (
            <Avatar size={120} icon={<UserOutlined />} />
          )}
          <h2 style={{ marginTop: 16, marginBottom: 0 }}>{user?.name}</h2>
          <p style={{ color: "rgba(0, 0, 0, 0.45)" }}>{user?.designation}</p>
        </div>

        <Descriptions bordered column={1}>
          <Descriptions.Item label="Seller ID">{user?.sellerId || "-"}</Descriptions.Item>
          <Descriptions.Item label="Name">{user?.name || "-"}</Descriptions.Item>
          <Descriptions.Item label="Username">{username || "-"}</Descriptions.Item>
          <Descriptions.Item label="Organization">{user?.organization || "-"}</Descriptions.Item>
          <Descriptions.Item label="Designation">{user?.designation || "-"}</Descriptions.Item>
          <Descriptions.Item label="Email">{user?.email || "-"}</Descriptions.Item>
          <Descriptions.Item label="Phone">{user?.phone || "-"}</Descriptions.Item>
          <Descriptions.Item label="Address">{user?.address || "-"}</Descriptions.Item>
          <Descriptions.Item label="Token Balance">
            <span style={{ fontWeight: "bold" }}>
              {user?.tokenBalance?.toLocaleString() || "0"}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="Two-Factor Authentication">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Switch 
                checked={user?.twoFactorEnabled} 
                onChange={handleToggle2FA} 
                loading={isLoading}
              />
              <span style={{ marginLeft: '10px', color: 'rgba(0, 0, 0, 0.65)' }}>
                {user?.twoFactorEnabled ? 'Enabled' : 'Disabled'}
              </span>
            </div>
          </Descriptions.Item>
        </Descriptions>
      </Space>
    </Card>
  );
};

export default ProfilePage; 